import React, { useEffect, useState } from "react";
import "./Testimonials.css";

const testimonials = [
  {
    id: 1,
    name: "Amala Sherin",
    rating: 5,
    message:
      "I started taking my son to Jeba mam when he was 4 & 1/2 years old.At this phase in life when we started,he was basically like a 1 year old baby.From mam,he started learning almost all the basic things in life ie things as elementary as sipping water from a bottle,eating all textures of food(Food was No.1 challenge after he turned 2 years),pedaling a bicycle,gripping a pencil,physical activities like hopping,jumping,skipping and climbing to name a few. At my son's age of 4 & 1/2 years, as parents we were almost hopeless and had many questions in life but now at age 6 seeing what my kid can do,I am extremely grateful to Jeba mam as I have found hope through her.As a family,we always see her as an Angel sent from above in our son's life.Today as I am writing this,I can thank God and Jeba mam as my son is far far better and a much improved little boy running around.I would strongly recommend Jeba mam to any parents seeking help for their kids.",
  },
  {
    id: 2,
    name: "Supriya Pandey",
    rating: 5,
    message:
      "My son had gone to Ms. Jaba for OT. He showed tremendous improvement in this time. She doesn't force kids to do specific activities, rather understands their interests and weakness to ensure a good mix of well structured session. My son showed improvement and had fun at the same time. Nothing more I can ask as a parent. Thanks to her efforts and kudos to the patience she shows with the kids.",
  },
  {
    id: 3,
    name: "Allen Devadoss",
    rating: 5,
    message:
      "I have known Jeba mam since 2023.She is a very committed,dedicated and a top notch professional.My son's life has completely transformed ever since we started to go to Jeba mam and her impact has been vividly noticed. The sound professional knowledge mam possesses is exceptional.What sets mam apart from the rest is pure emphaty, care,compassion and understanding of the kids exact need.I strongly recommend Jeba mam to any parent looking for any therapist/help for their kids.For a parent,nothing is more precious than seeing their kids improve, grow and adapt in life starting from zero when we went to mam.I want to sincerely express gratitude to mam for her impact on our lives.",
  },
  {
    id: 4,
    name: "Deva Precella",
    rating: 5,
    message:
      "Dr. Jabanal, is a very good Occupational Therapist and personally known to us. She has excellent knowledge and a deep understanding of both kids and parents. She always motivates us and guides us with great patience and care. I strongly recommend her for pediatric occupational therapy.",
  },
  {
    id: 5,
    name: "Shanmuga Sunder",
    rating: 5,
    message:
      "The title The Gifted Child carries a powerful message: do not let hopelessness blind you to the fact that God has bestowed a unique gift upon your child, one that the world cannot see. My son, Samuel, is a living witness to the progress so far, made possible by God’s work through Sister Jabanol. Thank you so much.***Matthew 19:14****",
  },
  {
    id: 6,
    name: "Vinola",
    rating: 5,
    message:
      "Jaba Mam is exceptionally good in handling kids. She also ensures the tasks are achieved and gives timely feedback. She is excellent in her work.",
  },
  {
    id: 7,
    name: "Anita Edwin",
    rating: 5,
    message:
      "Doctor jabanol have a special gift, both personally and professionally.You are a fantastic doctor who uses your touch to heal and make the little ones happy.I appreciate your dedication, kindness, and diligence in developing mind and body.improve daily operations.I heartily endorse.i strongly recommend this doctor for higher standard of life.",
  },
  {
    id: 8,
    name: "Mohana Divya Yelukuru",
    rating: 5,
    message:
      "Mam given the therapy for daily living, such cycling, color sorting, cognitive games, puzzles as well as social and emotional management. Thank you so much for ur support mam...",
  },
  {
    id: 9,
    name: "Selva Kumar",
    rating: 5,
    message:
      "Dr.Jabanal mam assess the child carefully and provides the exact therapy based on the level. She ensures that child achieves goals and progress to the next stage. My child has reached age appropriate milestones and now attending mainstream school.im truly happy with her work. I highly recommend other parents to try therapy for good results.",
  },
  {
    id: 10,
    name: "Ragu Nathan",
    rating: 5,
    message:
      "Jaba maam provides therapy with great care and expertise. She is highly experienced and knows exactly how to work with children. Thank you for your sincere efforts. I strongly recommend her.",
  },
  {
   id: 11,
    name: "Lavi",
    rating: 5,
    message:
      "The therapy center is really excellent, and Jabnal ma’am is guiding the therapists very well. She is an outstanding occupational therapist with a high level of skill in every area. She works with great dedication and focuses on all aspects of the child’s development. Since joining the therapy, my child has become much calmer and more settled. I no longer notice major sensory issues, and even the behavior concerns have improved significantly. The progress in speech has also very good . I will surely recommend this place",
  },
];

export default function Testimonials() {
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    document.title = "Testimonials | Gifted Child Therapy";
  }, []);

  const toggleExpand = (id) => {
    setExpanded(expanded === id ? null : id);
  };

  return (
    <div className="testimonials-container">

      {/* Banner */}
      <div className="testimonials-banner">
        <img src="/testimonialsBanner.png" alt="Testimonials Banner" className="banner-img" />
        <div className="banner-overlay">
          <h1 className="banner-title">Testimonials</h1>
        </div>
      </div>

      {/* Reviews */}
      <div className="container reviews-section">
        <h3 className="section-title text-center mb-5">What Parents Say</h3>

        <div className="testimonials-grid">
          {testimonials.map((t) => (
            <div key={t.id} className="testimonial-card shadow-sm">

              <div className="testimonial-rating">
                {"★".repeat(t.rating)}
              </div>

              <p className={`testimonial-message ${expanded === t.id ? "expanded" : ""}`}>
                "{t.message}"
              </p>

              {t.message.length > 100 && (
                <button className="read-more-btn" onClick={() => toggleExpand(t.id)}>
                  {expanded === t.id ? "▲ Show Less" : "..."}
                </button>
              )}

              <h5 className="testimonial-name">{t.name}</h5>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
